// OAI Quantity Popover - namespaced version
(function(){
  if(!customElements.get('oai-quantity-popover')) {
    class OaiQuantityPopover extends HTMLElement {
      constructor(){
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.oai-quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.oai-quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.oai-quantity-popover__info');
        this.closeButton = this.querySelector('.oai-button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }
        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }
        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }
        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }
        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }
      togglePopover(event){
        event.preventDefault();
        if(event.type === 'mouseenter'){ this.eventMouseEnterHappened = true; }
        if(event.type === 'click' && this.eventMouseEnterHappened) return;
        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button && button.getAttribute('aria-expanded') === 'true';
        if(((this.mql.matches && !isExpanded) || event.type === 'click') && button){
          button.setAttribute('aria-expanded', !isExpanded);
          if(this.popoverInfo) this.popoverInfo.toggleAttribute('hidden');
          button.classList.toggle('oai-quantity-popover__info-button--open');
          if(this.infoButtonDesktop) this.infoButtonDesktop.classList.add('oai-quantity-popover__info-button--icon-only--animation');
        }
        const isOpen = button && button.getAttribute('aria-expanded') === 'true';
        if(isOpen && event.type !== 'mouseenter' && button){
          button.focus();
          button.addEventListener('keyup', (e)=>{ if(e.key==='Escape'){ this.closePopover(e); } });
        }
      }
      closePopover(event){
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop && event.relatedTarget ? this.infoButtonDesktop.contains(event.relatedTarget) : false;
        const isPopoverChild = this.popoverInfo && event.relatedTarget ? this.popoverInfo.contains(event.relatedTarget) : false;
        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        if(button && !isButtonChild && !isPopoverChild){
          button.setAttribute('aria-expanded','false');
          button.classList.remove('oai-quantity-popover__info-button--open');
          if(this.popoverInfo) this.popoverInfo.setAttribute('hidden','');
          if(this.infoButtonDesktop) this.infoButtonDesktop.classList.remove('oai-quantity-popover__info-button--icon-only--animation');
        }
        this.eventMouseEnterHappened = false;
      }
    }
    customElements.define('oai-quantity-popover', OaiQuantityPopover);
  }
})();
